import { Spin } from "antd";
import React, { useEffect, useState } from "react";
import CanvasJSReact from "../../assets/canvasjs.react";
import CanvasJS from "../../assets/canvasjs.min";

const CanvasJSChart = CanvasJSReact.CanvasJSChart;

const PieChartsShow = ({ title, data = [], isLoading = false, type, chartType }) => {
  CanvasJS.addColorSet("greenShades", ["#3f9ffb", "#3ffbe8", "#f36a08", "#3ffb42", "#fb3f6b"]);

  const [options, setOptions] = useState({})


  useEffect(() => {
    if (data.length > 0) {
      const dt = data.map(d => {
        return {
          name: d.device,
          label: d.device,
          y: d.value
        }
      })


      setOptions({
        zoomEnabled: true,
        animationEnabled: false,
        title: {
          text: title,
          textTransform: 'capitalize',
        },
        toolTip: {
          shared: true
        },

        data: [{
          type: "pie",
          startAngle: 75,
          toolTipContent: "<b>{label}</b>: {y}%",
          showInLegend: "true",
          legendText: "{label}",
          indexLabelFontSize: 16,
          indexLabel: "{label} - {y}%",
          dataPoints: dt
        }],
      })
    }
  }, [])





  return (
    <Spin spinning={isLoading}>
      <CanvasJSChart options={options} />
    </Spin>
  );
};

export default PieChartsShow;
